<template>



    <div class="modal modal-active">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">{{ _lang('Remove domain') }}</div>
             <span class="close" @click="close">&times;</span>
          </div>
           <div class="modal-body">
               <div class="form-group">
                <dl>
                    <dt>{{ _lang('Domain')}}</dt>
                    <dd>{{project.domain}}</dd>
                </dl>
               </div>

                <div class="mt-2">
                    <button v-if="!isProcessing" class="btn btn-danger" @click="removeDomain">{{ _lang('Remove')}}</button>
                </div>

                    <div v-if="isProcessing">
                      <progress />
                    </div>

                    <div class="form-group mt-2" v-if="response">
                        <label>{{ _lang('Response')}}:</label>
                        <div class="alert alert-info">{{response}}</div>
                    </div>



           </div>
         </div>
       </div>
    </div>


</template>

<script>
import axios from 'axios';
export default {
    props:['project','active'],

    data(){
        return {
            response:'',
            isProcessing:false,
        }
    },
    methods:{

        close(){
            this.$emit('close');
        },
    removeDomain(){

      this.response = '';

      this.isProcessing = true;

      axios({
        method: 'post',
        url: '/api/remove-domain/'+this.project.id,
      }).then((res) => {
        this.response = res.data;
        this.isProcessing = false;
        window.location.reload();
      }).catch(err=>{
        this.isProcessing = false;
        this.response = JSON.stringify(err.response);
      });



    },

    },


}
</script>

<style scoped>

</style>
